import { FETCH_BOLETOS } from '../actions/types';

export default function (state = [], action) {
    switch (action.type) {
        case FETCH_BOLETOS:
            return action.payload;
        default:
            return state;
    }
}